import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import {
  AUTO_DEBIT_getNachStatus_API_CALL,
  AUTO_DEBIT_getNachStatus_API_CALL_extrareducer,
} from './auto-debit/api/get-nach-status';
import autoDebitInitialState from './auto-debit/api/initial-state-auto-debit';
import { autoDebitSyncFnReducers } from './auto-debit/functions/auto-debit-sync-fn-reducers';

export const autoDebitSlice = createSlice({
  name: 'autoDebit',
  initialState: autoDebitInitialState,
  reducers: {
    ...autoDebitSyncFnReducers,
  },
  extraReducers: {
    ...AUTO_DEBIT_getNachStatus_API_CALL_extrareducer,
  },
});

export const {
  updateCurrentScreen,
  updatePreviousScreen,
  toggleGlobalOverlayLoader,
  toggleRightSidebar,
  toggleShowWelcomeScreen,
  updateAckScreenData,
  toggleNachUploadMethodButton,
  toggleUploadNACHFormBtnClicked,
  toggleShowBankDetailsScreen,
  toggleAddtionalDocsSorryScreen,
  toggleSkipAdOnlineThreeChoicesScreen,
  toggleCustomerComingFromSSOJourney,
  toggleIsEligibleForEmandateCancellation,
} = autoDebitSlice.actions;

export const useAutoDebitStore = () => {
  const autoDebitState = useSelector((state) => state.autoDebit);
  const currentScreen = useSelector((state) => state.autoDebit.currentScreen);
  const previousScreen = useSelector((state) => state.autoDebit.previousScreen);
  const isEligibleForEmandateCancellation = useSelector(
    (state) => state.autoDebit.isEligibleForEmandateCancellation
  );
  const dispatch = useDispatch();

  return {
    autoDebitState,
    currentScreen,
    previousScreen,
    isEligibleForEmandateCancellation,

    // DOCS: Sync Actions declared here
    updateCurrentScreen: (payload) => dispatch(updateCurrentScreen(payload)),
    updatePreviousScreen: (payload) => dispatch(updatePreviousScreen(payload)),
    toggleGlobalOverlayLoader: (payload) =>
      dispatch(toggleGlobalOverlayLoader(payload)),
    toggleRightSidebar: (payload) => dispatch(toggleRightSidebar(payload)),
    toggleUploadNACHFormBtnClicked: (payload) =>
      dispatch(toggleUploadNACHFormBtnClicked(payload)),
    updateAckScreenData: (payload) => dispatch(updateAckScreenData(payload)),
    toggleShowWelcomeScreen: (payload) =>
      dispatch(toggleShowWelcomeScreen(payload)),
    toggleShowBankDetailsScreen: (payload) =>
      dispatch(toggleShowBankDetailsScreen(payload)),
    toggleNachUploadMethodButton: (payload) =>
      dispatch(toggleNachUploadMethodButton(payload)),
    toggleAddtionalDocsSorryScreen: (payload) => {
      dispatch(toggleAddtionalDocsSorryScreen(payload));
    },
    toggleIsEligibleForEmandateCancellation: (payload) => {
      dispatch(toggleIsEligibleForEmandateCancellation(payload));
    },

    // DOCS: API Async Actions declared here
    getNachStatusAPICall: (payload) =>
      dispatch(AUTO_DEBIT_getNachStatus_API_CALL(payload)),
    toggleSkipAdOnlineThreeChoicesScreen: (payload) => {
      dispatch(toggleSkipAdOnlineThreeChoicesScreen(payload));
    },
    toggleCustomerComingFromSSOJourney: (payload) =>
      dispatch(toggleCustomerComingFromSSOJourney(payload)),
  };
};

export default autoDebitSlice.reducer;
